module.exports = __webpack_public_path__ + "img/logo-cem.183c1aa9.png";